import apiService from "../../service/apiService";
import { cloneDeep } from "lodash";
import URL from "@/constants/baseurl";

export default {
    namespaced: true,
    state: () => ({
        bills: [],

        bill_filters: {
            bill_ref: '',
            franchisee_id: '',
            status: '',
            page: 1,
        }

    }),
    mutations: {
        SET_BILLS(state, bills) {
            state.bills = bills;
        }

    },
    actions: {

        set_bills({ commit }, data) {
            commit('SET_BILLS', data);
        },

        async get_bills({ state, commit }) {
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-franchisee-bills`;

            let filters = {
                bill_ref: state.bill_filters.bill_ref,
                franchisee_id: state.bill_filters.franchisee_id,
                status: state.bill_filters.status,
                page: state.bill_filters.page,
            };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                commit('SET_BILLS', res);
            } catch (error) {
                console.error('Error fetching franchisee bills:', error);
            }
        }

    },
    getters: {}
}
